<script setup lang="ts">
import Toaster from './toast/Toaster.vue'

defineOptions({
  name: 'FaNotification',
})
</script>

<template>
  <Toaster />
</template>
